import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProducts } from './productService';
import { handleApiError } from '../../api/errorHandler';

export const fetchProducts = createAsyncThunk(
  'products/fetchAll',
  async (_, { rejectWithValue, signal }) => {
    try {
      return await getProducts({ signal });
    } catch (error) {
      return rejectWithValue(handleApiError(error));
    }
  },
  {
    condition: (_, { getState }) => {
      const { status } = getState().products;
      return status !== 'succeeded'; // Only prevent if already succeeded
    },
  }
);
